export default {
  loading: false,
  locations: [],
  taxAuthorities: [],
  location: {},
  defaultLocation: {},
};
